import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import { EditableProps } from "@builder/components/editable/editableProps";
import TextInput from "@builder/components/general/TextInput";
import Toggle from "@builder/components/general/Toggle";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { updateNodeProperty } from "@builder/store/slices/BuilderSlice/builderSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { CustomerNotesNode } from "@common/build/types";
import { useState } from "react";

const EditCustomerNotes = ({ parent }: EditableProps) => {
    const dispatch = useAppDispatch();
    const nNode = useAppSelector(getSelectedNode) as CustomerNotesNode;

    const [showTitle, setShowTitle] = useState(!!nNode.title?.text);
    const [showAddNoteButton, setShowAddNoteButton] = useState(!!nNode.addNoteButton?.text);

    const updateOrRemove = (path: string[], value: any, remove: boolean) => {
        dispatch(updateNodeProperty({ propertyPath: path, value, remove }));
    }

    const handleTextUpdate = (path: string, value: string) => {
        dispatch(updateNodeProperty({ propertyPath: [path, "text"], value }));
    }

    const showDateText = nNode.dateText !== undefined;
    const showTimeText = nNode.timeText !== undefined;
    const showDeleteNoteIcon = nNode.deleteNoteIcon !== undefined;

    return (
        <SidebarCollapse title="Customer notes setup" parent={parent}>
            <Toggle 
                label="Show title" 
                checked={showTitle} 
                callback={() => {
                    updateOrRemove(["title"], showTitle ? "" : {text:"Customer Notes"}, showTitle);
                    setShowTitle(!showTitle);
                }}
            />
            {showTitle && (
                <TextInput  
                    placeholder="Enter title" 
                    value={nNode.title?.text || ""} 
                    callback={(value: string) => handleTextUpdate("title", value)} 
                />
            )}

            <Toggle 
                label="Show add note button" 
                checked={showAddNoteButton} 
                callback={() => {
                    updateOrRemove(["addNoteButton"], showAddNoteButton ? "" : {text:"Add note"}, showAddNoteButton);
                    setShowAddNoteButton(!showAddNoteButton);
                }} 
            />
            {showAddNoteButton && (
                <TextInput  
                    placeholder="Enter button text" 
                    value={nNode.addNoteButton?.text || ""} 
                    callback={(value: string) => handleTextUpdate("addNoteButton", value)} 
                />
            )}

            <Toggle 
                label="Show date" 
                checked={showDateText} 
                callback={() => updateOrRemove(["dateText"], showDateText ? "" : {}, showDateText)} 
            />

            <Toggle 
                label="Show time" 
                checked={showTimeText} 
                callback={() => updateOrRemove(["timeText"], showTimeText ? undefined : {}, showTimeText)} 
            />

            <Toggle 
                label="Show delete icon" 
                checked={showDeleteNoteIcon} 
                callback={() => updateOrRemove(["deleteNoteIcon"], showDeleteNoteIcon ? "" : "Delete", showDeleteNoteIcon)} 
            />
        </SidebarCollapse>
    );
};

export default EditCustomerNotes;